export class DataCatalogDatasetHealth {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "DataCatalogDatasetHealthStatus",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "Array<DataCatalogDatasetHealthIssue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogDatasetHealth.attributeTypeMap;
    }
    constructor() {
    }
}
